import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const NewsArticleSchema = ({ headline, mainEntityId, imageUrl, datePublished, dateModified, schemaDescription, langUrl }) => {
// console.log(imageUrl.node.mediaDetails.sizes,"imageUrl");
// const sizesArray = imageUrl.node.mediaDetails.sizes.map(size => ({
//   name: size.name,
//   width: size.width,
//   height: size.height,
//   sourceUrl: size.sourceUrl
// }));
  const schemaData = {
  "@context": "https://schema.org",
  "@type": "NewsArticle",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": mainEntityId
  },
  "headline": headline,
  "description": schemaDescription,  
  "image": imageUrl.node.mediaDetails.sizes.map(image => ({
      "@type": "ImageObject",
      "url": image.sourceUrl,
    })),
  "author": {
    "@type": "Organization",
    "name": ""
  },  
  "publisher": {
    "@type": "Organization",
    "name": langUrl,
    "logo": {
      "@type": "ImageObject",
      "url": "https://jameelmotors.com/static/jameelMotorsLogoBlue-c1230052e1ca5d2b85509960d85d4471.svg"
    }
  },
  "datePublished": datePublished
  };

  console.log(mainEntityId,"mainEntityId");
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

NewsArticleSchema.propTypes = {
  headline: PropTypes.string.isRequired,
  mainEntityId: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string,
};

NewsArticleSchema.defaultProps = {
  dateModified: '',
};

export default NewsArticleSchema;
